<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="addLogo" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-row(vm-justify="space-between")
            b {{ $t('customers.with_company_logo') }}
            vm-switch(v-model="form.with_company_logo")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        span(class="attached-custom__text") {{ $t('shipments.add_file') }}
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        .attached-custom
          .attached-custom__card(@dragover='dragover' @dragleave='dragleave' @drop='drop')
            div(class="attached-custom__card__placeholder" v-if='!this.filelist.length')
              vm-icon(icon="cloud-upload-outline" size="2rem")
              label(for='files')
                span {{ $t('shipments.description_attached') }}
              vm-button(@click="onDialogFileOpen" size="medium") {{ $t('shipments.select_file') }}
            div(class="attached-custom__card__grid" v-else='')
              div(class="attached-custom__card__grid__item" v-for='(file, index) in filelist' :key="index")
                header
                  img(:src='checkFormat(file.name)' @click="onShowFile(file)")
                  .attached-custom__card__grid__item__dropdown
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="flat" icon="more-vertical" color="#afbbc6" size="small")
                      vm-dropdown-menu
                        vm-dropdown-item.d-flex.justify-content-between(@click="remove(index, file)")
                          vm-icon(icon="trash-2-outline")
                          slot &nbsp;{{ $t('strings.delete') }}
                footer
                  img(:src='checkFormat(file.name)')
                  span {{ getFileNameFormated(file.name) }}
              vm-button(@click="onDialogFileOpen" size="medium" class="attached-custom__upload" icon="plus" v-if="")
          input(class="attached-custom__file" id="files" type='file' multiple='' name='fields[files][]' @change='onChange' ref='file' accept='.png,.jpg,.jpeg')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'ModalCustomers',
  mixins: [ModalMixin1],
  data: () => ({
    file: {},
    filelist: []
  }),
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'saveTrackingGuideFiles'
    ]),
    close () {
      this.setModalVisible(false)
    },
    onDialogFileOpen () {
      this.$refs.file.click()
    },
    onShowFile (file) {
      const ext = file.name.split('.').pop()
      if (file.id && ext === 'pdf') {
        this.$viewer.show({
          urlFile: file.file_url,
          mime: file.mime_type,
          name: file.name,
          color: '#FFF'
        })
      } else if (file.id && ext !== 'pdf') {
        this.openFile(file.file_url)
      }
    },
    onChange () {
      if (this.filelist.length < 5) {
        this.file = this.$refs.file.files[0]
        this.filelist.push(...this.$refs.file.files)
        this.$emit('onChange', this.filelist)
      }
    },
    async remove (index, file) {
      if (file.id) {
        await this.deletedFile({ id: file.id })
      }
      this.filelist.splice(index, 1)
    },
    dragover (event) {
      event.preventDefault()
      if (!event.currentTarget.classList.contains('attached-custom__card--dragover')) {
        event.currentTarget.classList.add('attached-custom__card--dragover')
      }
    },
    dragleave (event) {
      event.currentTarget.classList.remove('attached-custom__card--dragover')
    },
    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange()
      event.currentTarget.classList.remove('attached-custom__card--dragover')
    },
    getFileNameFormated (file) {
      return file.replace(/\.[^/.]+$/, '')
    },
    checkFormat (file) {
      const type = file.split('.').pop()
      if (type === 'dwg' || type === 'dxf') {
        return require('@/assets/icons/auto.png')
      } else if (type === 'pdf') {
        return require('@/assets/icons/pdf.svg')
      } else if (type === 'xls' || type === 'spread' || type === 'xlsx') {
        return require('@/assets/icons/excel.svg')
      } else {
        return require('@/assets/icons/auto.png')
      }
    },
    addLogo () {
      const data = {
        ...this.form,
        files: this.filelist
      }
      this.saveTrackingGuideFiles(data).then(() => {
        this.setModalVisible(false)
        this.form = {}
        this.filelist = []
        this.file = {}
      })
    }
  }
}
</script>
<style lang="scss">
.attached-custom {
  margin: 20px 0;
  &__card {
    background-color: #F2F4F7;
    display: flex;
    min-height: 150px;
    border-radius: 8px;
    border: 3px dashed #B1B1B1;
    padding: 25px 35px;
    position: relative;
    &--dragover {
      background-color: rgba($color: var(--success), $alpha: 0.5);
      border: 3px dashed rgba($color: var(--success), $alpha: 1.0);
    }
    &__placeholder {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      & label {
        margin: 16px 0 10px 0;
        & span {
          font-size: 14px;
          font-weight: 400;
          color: #8A8A8A;
        }
      }
      & button {
        font-weight: 700;
        font-size: 16px;
      }
    }
    &__grid {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px;
      &__item {
        background-color: white;
        border-radius: 0.5em;
        box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
        cursor: pointer;
        &__dropdown {
          position: absolute;
          top: 0;
          right: 0;
        }
        & header {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 125px;
          border-bottom: 1px solid #f0f0f0;
          padding: 10px;
          position: relative;
          img {
            width: 50px;
          }
        }
        & footer {
          padding: 10px;
          display: flex;
          & img {
            width: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  &__file {
    display: none;
  }
  &__upload {
    position: absolute;
    bottom: 5px;
    right: 5px;
    border-radius: 50%;
  }
  // remove clasess
  &__text {
    font-weight: bold;
  }
  &__note {
    label {
      color: black;
      font-weight: bold;
    }
  }
}
</style>
